"use strict";
'use client';
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apps_shared_1 = require("@l2p/apps-shared");
var swr_hooks_1 = require("@l2p/swr-hooks");
var react_1 = __importStar(require("react"));
var DesktopGames_1 = __importDefault(require("./DesktopGames"));
var MobileGames_1 = __importDefault(require("./MobileGames"));
var MobileGamesVertical_1 = __importDefault(require("./MobileGamesVertical"));
var GamesByCategories = function (_a) {
    var categoriesToShow = _a.categoriesToShow, _b = _a.navigationPosition, navigationPosition = _b === void 0 ? 'top' : _b, _c = _a.withIcon, withIcon = _c === void 0 ? false : _c, _d = _a.isMobileVertical, isMobileVertical = _d === void 0 ? false : _d;
    var breakpoints = (0, apps_shared_1.useBreakpoint)();
    var gamesByCategories = (0, swr_hooks_1.useGamesByCategories)().data;
    var gamesByThemeCategories = (0, react_1.useMemo)(function () {
        return categoriesToShow
            .filter(function (collection) { return collection.place === 'byCategories'; })
            .map(function (item) { return item.slug; });
    }, [categoriesToShow]);
    var preparedCollections = (0, react_1.useMemo)(function () {
        var result = [];
        if (gamesByCategories)
            gamesByThemeCategories.forEach(function (collection) {
                var _a, _b;
                var games = ((_a = gamesByCategories[collection]) === null || _a === void 0 ? void 0 : _a.previewGames) || [];
                if (games && games.length > 0)
                    result.push({
                        collectionSlug: collection,
                        games: (games === null || games === void 0 ? void 0 : games.slice(0, 6)) || [],
                        count: (_b = gamesByCategories[collection]) === null || _b === void 0 ? void 0 : _b.gameCount,
                    });
            });
        return result;
    }, [gamesByThemeCategories, gamesByCategories]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        Object.keys(breakpoints).length > 0 &&
            !breakpoints.mobile &&
            !breakpoints.tablet && (react_1.default.createElement(DesktopGames_1.default, { preparedCollections: preparedCollections, navigationPosition: navigationPosition, withIcon: withIcon })),
        Object.keys(breakpoints).length > 0 &&
            (breakpoints.mobile || breakpoints.tablet) &&
            isMobileVertical && (react_1.default.createElement(MobileGamesVertical_1.default, { preparedCollections: preparedCollections.map(function (c) { return (__assign(__assign({}, c), { games: c.games.slice(0, 3) })); }) })),
        Object.keys(breakpoints).length > 0 &&
            (breakpoints.mobile || breakpoints.tablet) &&
            !isMobileVertical && (react_1.default.createElement(MobileGames_1.default, { preparedCollections: preparedCollections }))));
};
exports.default = react_1.default.memo(GamesByCategories);
